import "./GamingVPNs.module.css";
import Header from "@/reusable_sections/Header";
import GamingHero from "./sections/GamingHero";
import Gamingbenefitsgrid from "./sections/Gamingbenefitsgrid";
import Vpnroutingoptimization from "./sections/Vpnroutingoptimization";
import Ddosprotectionbenefits from "./sections/Ddosprotectionbenefits";
import Gamingfreedomprotocol from "./sections/Gamingfreedomprotocol";
import Vpnperformancecomparison from "./sections/Vpnperformancecomparison";
import Gamingvpnperformancecta from "./sections/Gamingvpnperformancecta";
import Relatedgamingarticles from "./sections/Relatedgamingarticles";
import Affiliategamingcta from "./sections/Affiliategamingcta";
import Footer from "@/reusable_sections/Footer";
export default function GamingVPNsPage() {
  return <div>
      <Header />
      <GamingHero />
      <Gamingbenefitsgrid />
      <Vpnroutingoptimization />
      <Ddosprotectionbenefits />
      <Gamingfreedomprotocol />
      <Vpnperformancecomparison />
      <Gamingvpnperformancecta />
      <Relatedgamingarticles />
      <Affiliategamingcta />
      <Footer />
    </div>;
}